

























































import { Component, Vue } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import {
  GETTER_CURRENT_USER_MEDIA_LIST,
  GETTER_CURRENT_POST_ID,
  UPDATE_CURRENT_POST_ID
} from "@/store/constants/ins_media_types";
import { simplify } from "@/utils/num_utils";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: {
    ImgFetched
  }
})
export default class InsMedia extends Vue {
  @Mutation(UPDATE_CURRENT_POST_ID)
  private updateCurrentPostId: any;
  @Getter(GETTER_CURRENT_USER_MEDIA_LIST)
  private currentMediaList: any;
  @Getter(GETTER_CURRENT_POST_ID)
  private currentPostId: any;

  private isActiveItem(item: any) {
    return this.currentPostId === item.id;
  }

  private isVideoPost(post: any) {
    return post && post.is_video;
  }

  private isMultiplePost(post: any) {
    return post && post.media_type && post.media_type === 8;
  }

  get simplify() {
    return simplify;
  }

  get mediaList() {
    return this.currentMediaList && this.currentMediaList.ins_media_list;
  }

  private clickItem(post: any) {
    this.updateCurrentPostId(post.id);
    this.$emit("closeProup");
  }
}
